import { render, staticRenderFns } from "./TeamleaderTaskSummary.vue?vue&type=template&id=389a028f&"
import script from "./TeamleaderTaskSummary.vue?vue&type=script&lang=js&"
export * from "./TeamleaderTaskSummary.vue?vue&type=script&lang=js&"
import style0 from "./TeamleaderTaskSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports